import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { getContact } from "../services/contactService";


import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import "../styles/Contact.css";

export default function Contact() {

    const { id } = useParams();

    const [content, setContent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {

        const loadContent = async () => {

            try {

                setLoading(true);

                const response = await getContact();

                setContent(response.data);

            } catch (error) {

                console.error("Failed to load content:", error);

                setError("Content not found.");

            } finally {

                setLoading(false);
            }
        };

        loadContent();

    }, [id]);

    if (loading) {
        return (
            <div className="content-detail">
                Loading...
            </div>
        );
    }

    if (error || !content) {
        return (
            <div className="content-detail">
                <h2>Contact not found</h2>
            </div>
        );
    }


    delete L.Icon.Default.prototype._getIconUrl;

    L.Icon.Default.mergeOptions({
        iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
        iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
        shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
    });

      window.scrollTo({
            top: 0,
            behavior: "smooth",
        });


    return (
        <article className="content-detail">

            <div className="content-detail__container">

                {content.title && (
                    <div className="content-detail__title-image">

                        <img
                            src={content.image}
                            alt={content.title}
                        />

                    </div>
                )}

                <h1 className="content-detail__title">
                    {content.title}
                </h1>





                <div
                    className="content-detail__content"
                    dangerouslySetInnerHTML={{
                        __html: content.content
                    }}
                />

                <div className="section-map">

                    <div className="google-map">
                        <a href="https://goo.gl/maps/am4BTzFBoZPG6zc48" target="_blank" className="btn-map">
                            <i className="fa fa-map-marker"></i>
                            مشاهده نقشه گوگل
                        </a>
                    </div>

                    <div className="leaf">
                        <MapContainer center={[35.757403, 51.311203]} zoom={13} style={{ height: '60vh', width: '100%' }}>
                            <TileLayer
                                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            />
                            <Marker position={[35.757403, 51.311203]}>
                                <Popup>
                                    فروشگاه اینترنتی <br />  کافه دارو 
                                </Popup>
                            </Marker>
                        </MapContainer>
                    </div>

                </div>



            </div>

        </article>
    );
}